import React from 'react';

// Basic Detail Section
const BasicDetail = ({data,pageJson,translations,countryList,getCountryTaxonomy}) => {
    if(pageJson !== undefined){
      return (
        <div className="ie-detail-container">
          <div className="ie-detail-container__heading">{`1. ${translations(pageJson.pageHeading)}`}</div>
          <div className="ie-detail-container__content">
            <dl className="ie-detail-container__horizontal-row">
              <dt>{translations(pageJson.textAgent)}:</dt>
              <dd>{data.glsAgent !== undefined ? data.glsAgent.name : ''}</dd>
              <dt>{translations(pageJson.textType)}:</dt>
              <dd>{data.glsProductType !== undefined ? data.glsProductType.name : ''}</dd>
              <dt>Relationship Bank of GLS Product:</dt>
              <dd>{data.relationshipBank !== undefined ? countryList !==undefined? getCountryTaxonomy(data.relationshipBank).name :data.relationshipBank.name : ''}</dd>
              <dt>{translations(pageJson.textAccounts)}:</dt>
              <dd>{data.marginApplicable === false ? 'No' : 'Yes'}</dd>
              <dt>{translations(pageJson.textTitle)}:</dt>
              <dd>{data.interestEnhancementTitle}</dd>
            </dl>
          </div>
        </div>
      )
    }else {
      return ''
    }
}

export default BasicDetail;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/IEPreview/BasicDetail.js